import React, { Component } from "react";
import S from "../../../styles/components";
import connectToMedia from "../../Media/connectToMedia";
import memoizeOne from "memoize-one";
import TimeLabel from "../../Labels/TimeLabel";
import Slider from "../../../common/Slider";
import ToolTip from "../../../common/ToolTip";
import Button from "../../../common/Button";
import Draggable from "react-draggable";
import Circle from "../../../assets/icons/circle.gif";
import closeIcon from "../../../assets/icons/close.svg";
import maximizeIcon from "../../../assets/icons/maximize.svg";
import playNextPreviousMedia from "../utils/playNextPreviousMedia";
import VoicebaseReactPlayerContext from "../../../VoicebaseReactPlayerContext";

const mapStateToProps = (state) => ({ ...state.media, queries: state.query });

class Index extends React.PureComponent {
  static contextType = VoicebaseReactPlayerContext;

  constructor(props) {
    super(props);
    this.state = {
      nextColor: "#677791",
      onHoverPlay: true,
    };
  }
  skipBackward = () => {
    const { onSeek, duration, currentTime } = this.props;
    const skipTime = currentTime - 15000; // currentTime - (duration / 20);
    onSeek({ s: skipTime < 0 ? 0 : skipTime });
  };
  getHitMarks = memoizeOne(
    (queries) =>
      queries &&
      []
        .concat(...queries.map((query) => query.hits))
        .reduce(
          (acc, hit) => ({ ...acc, [_.get(hit, "s", [])]: <S.ProgressMark /> }),
          {}
        )
  );
  seek = (value) => {
    const { onSeek, duration } = this.props;
    onSeek({ s: value });
  };
  play = () => {
    const { onPlay } = this.props;
    this.setState({ onHoverPlay: true });
    onPlay();
  };
  pause = () => {
    const { onPause } = this.props;
    onPause();
  };
  renderTooltip(value) {
    return <TimeLabel ms={value} />;
  }
  skipToEnd = () => {
    const { onSeek, duration } = this.props;
    onSeek({ s: duration });
  };

  render() {
    const {
      readyState,
      transcript,
      duration = 0,
      queries,
      currentTime = 0,
      paused,
      isMiniPlayerVisible,
      setClickMinMaxPlayerVisible,
      metaData,
      hidePlayer,
      mediaId,
    } = this.props;
    const loading = readyState < 2;
    const agentDetail = metaData?.detail;
    const agentExtendedName = `${
      agentDetail?.extended?.agent_first_name
        ? `${agentDetail?.extended?.agent_first_name} `
        : ""
    }${
      agentDetail?.extended?.agent_last_name
        ? agentDetail?.extended?.agent_last_name
        : ""
    }`;
    const agentName = agentDetail?.callDetails?.agent?.fullName;
    const parsedDate = agentDetail?.parsedDate || agentDetail?.startTime;
    return (
      <>
        {isMiniPlayerVisible && (
          <S.MiniPlayerContainer>
            <S.MiniPlayerBody>
              <Draggable handle="div">
                <div className="mini-player-draggable">
                  <S.MiniPlayerControlBar>
                    <S.PrimaryControls>
                      <div>
                        <S.PrimaryControlTitle>
                          {agentName || agentExtendedName || "No agent details"}
                        </S.PrimaryControlTitle>
                      </div>
                      <div>
                        <S.PrimaryControlSubTitle>
                          {parsedDate ? `on ${parsedDate}` : ""}
                        </S.PrimaryControlSubTitle>
                      </div>
                    </S.PrimaryControls>
                    <S.PrimaryControls className="minimize-icon">
                      <ToolTip
                        key={`Maximize`}
                        placement="bottom"
                        trigger={["hover"]}
                        overlay={<span>Maximize</span>}
                        style={{ minHeight: "auto" }}
                      >
                        <img
                          className="maximize-icon"
                          src={maximizeIcon}
                          alt="mini player maximize icon"
                          onClick={() => setClickMinMaxPlayerVisible()}
                        />
                      </ToolTip>
                      <ToolTip
                        key={`Close Player`}
                        placement="bottom"
                        trigger={["hover"]}
                        overlay={<span>Close Player</span>}
                        style={{ minHeight: "auto" }}
                      >
                        <img
                          className="mini-player-close-icon"
                          src={closeIcon}
                          alt="mini player close icon"
                          onClick={hidePlayer}
                        />
                      </ToolTip>
                    </S.PrimaryControls>
                  </S.MiniPlayerControlBar>
                  <S.MiniPlayerControlBar style={{ marginTop: "10px" }}>
                    <S.ProgressIconStyle
                      style={{ marginLeft: "0px", marginRight: "10px" }}
                    >
                      <ToolTip
                        key={`Rewind`}
                        placement="bottom"
                        trigger={["hover"]}
                        overlay={<span>Rewind</span>}
                        style={{ minHeight: "auto" }}
                      >
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={this.skipBackward}
                        >
                          <path
                            d="M4.98975 6.48218H1.98975V3.48218"
                            stroke="#677791"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.11107 12.1391C4.88025 12.9083 5.86026 13.4321 6.92716 13.6443C7.99405 13.8565 9.09992 13.7476 10.1049 13.3313C11.1099 12.9151 11.9689 12.2101 12.5732 11.3056C13.1776 10.4012 13.5002 9.3378 13.5002 8.25C13.5002 7.16221 13.1776 6.09884 12.5732 5.19437C11.9689 4.2899 11.1099 3.58495 10.1049 3.16867C9.09992 2.75238 7.99405 2.64346 6.92716 2.85568C5.86026 3.0679 4.88025 3.59173 4.11107 4.36092L1.98975 6.48224"
                            stroke="#677791"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </ToolTip>
                    </S.ProgressIconStyle>
                    <S.ProgressIcon style={{ marginTop: "-10px" }}>
                      {paused ? (
                        <ToolTip
                          key={`Play`}
                          placement="bottom"
                          trigger={["hover"]}
                          overlay={<span>Play</span>}
                          style={{ minHeight: "auto" }}
                        >
                          <Button
                            type="primary"
                            onClick={this.play}
                            loading={loading}
                            disabled={loading}
                            shape="circle"
                            size="lg"
                            icon="caret-right"
                          />
                        </ToolTip>
                      ) : (
                        <span
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        >
                          {this.state.onHoverPlay ? (
                            <img
                              src={Circle}
                              alt="loading..."
                              className="player-content"
                              onClick={this.pause}
                              loading={loading}
                              disabled={loading}
                              onMouseOver={() =>
                                this.setState({ onHoverPlay: false })
                              }
                            />
                          ) : (
                            <span className="mini-player-button">
                              <ToolTip
                                key={`Pause`}
                                placement="bottom"
                                trigger={["hover"]}
                                overlay={<span>Pause</span>}
                                style={{ minHeight: "auto" }}
                              >
                                <Button
                                  icon="pause"
                                  type="primary"
                                  size="lg"
                                  shape="circle"
                                  onClick={this.pause}
                                  loading={loading}
                                  disabled={loading}
                                  onMouseLeave={() =>
                                    this.setState({ onHoverPlay: true })
                                  }
                                />
                              </ToolTip>
                            </span>
                          )}
                        </span>
                      )}
                    </S.ProgressIcon>
                    <S.ProgressSlider
                      style={{ display: "inline-flex", width: "100%" }}
                    >
                      <Slider
                        horizontal
                        min={0}
                        max={duration}
                        value={currentTime}
                        tipFormatter={this.renderTooltip}
                        onChange={this.seek} // TODO: use a method call
                        style={{ margin: 5, flex: 1 }}
                        dotStyle={{ display: "none" }}
                      />
                    </S.ProgressSlider>
                    <S.ProgressIconStyle>
                      <ToolTip
                        key={`Next`}
                        placement="bottom"
                        trigger={["hover"]}
                        overlay={<span>Next</span>}
                        style={{ minHeight: "auto" }}
                      >
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onMouseOver={() =>
                            this.setState({ nextColor: "#262D38" })
                          }
                          onMouseLeave={() =>
                            this.setState({ nextColor: "#677791" })
                          }
                          onClick={() =>
                            playNextPreviousMedia({
                              ...this.context,
                              mediaId,
                              nextOrPrevious: "next",
                            })
                          }
                        >
                          <path
                            d="M1.5 8.64697H11.5"
                            stroke={this.state.nextColor}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M6.99951 13.147L11.4995 8.64697L6.99951 4.14697"
                            stroke={this.state.nextColor}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M13.5 13.647V3.64697"
                            stroke={this.state.nextColor}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </ToolTip>
                    </S.ProgressIconStyle>
                    <S.ProgressTime style={{ marginLeft: "10px" }}>
                      <TimeLabel ms={currentTime} /> /{" "}
                      <TimeLabel ms={duration} />
                    </S.ProgressTime>
                  </S.MiniPlayerControlBar>
                </div>
              </Draggable>
            </S.MiniPlayerBody>
          </S.MiniPlayerContainer>
        )}
      </>
    );
  }
}

export default connectToMedia(mapStateToProps)(Index);
